/**
 * @description Define supported roles
 */
export enum Role {
    CLIENT = 'Client',
}
